'use es6';

import { createSelector } from 'reselect';
import { getTrack, getTracksAreRequesting } from './trackSelectors';
import { getLesson, getLessonsAreRequesting } from './lessonSelectors';
import { getFavoriteedItems, getCumulativeFavoriteedItems } from './favoriteSelectors';
export const getAugmentedTracksLessonsSubset = createSelector(state => state, (_, {
  tracksLessonsSubset
}) => tracksLessonsSubset, (state, tracksLessonsSubset) => {
  return tracksLessonsSubset.map(item => {
    const trackLessonData = item.contentType === 'TRACK' ? getTrack(state, {
      trackId: `${item.id}`
    }) : getLesson(state, {
      lessonId: `${item.id}`
    });
    return Object.assign({}, item, {
      data: trackLessonData ? trackLessonData.toJS() : undefined
    });
  });
});
export const getTracksAndLessonsFavoriteed = createSelector(state => state, getFavoriteedItems, getCumulativeFavoriteedItems, (_, ownProps) => ownProps, (state, favorites, cumulativeFavorites, ownProps) => {
  const {
    includeRecentlyRemoved
  } = ownProps;
  return (includeRecentlyRemoved ? cumulativeFavorites : favorites).toJS().map(item => {
    if (item.trackId) {
      const track = getTrack(state, {
        trackId: `${item.trackId}`
      });

      if (track) {
        return Object.assign({
          trackId: item.trackId
        }, includeRecentlyRemoved ? {
          isRecentlyUnfavoriteed: !favorites.find(favoriteTrack => favoriteTrack.get('trackId', null) === item.trackId)
        } : {}, {}, track.toJS());
      }

      return null;
    }

    const lesson = getLesson(state, {
      lessonId: `${item.lessonId}`
    });

    if (lesson) {
      return Object.assign({
        lessonId: item.lessonId
      }, includeRecentlyRemoved ? {
        isRecentlyUnfavoriteed: !favorites.find(favoriteTrack => favoriteTrack.get('lessonId', null) === item.lessonId)
      } : {}, {}, lesson.toJS());
    }

    return null;
  }).filter(Boolean);
});
export const getIsRequestingTracksOrLessons = createSelector(state => state, getTracksAreRequesting, getLessonsAreRequesting, (_, ...values) => values.some(v => v));